module.exports = __webpack_public_path__ + "static/img/normal.f4651890.png";